export const css = {
	oneaction: 'RS8TgT0_',
	sureButtons: '_3pPQMQA0',
	timerblock: '_3NBlaNfM',
	primaryButton: '_1lfjtsPH',
	' _key': 'afcpe-theme/afcpe/micro/quiz-widgets/prometric-review'
};

export default css;
